import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { sampleCollectorGridColumns } from "../utilis/sampleCollectorGridColumns";
import { edit_sample_collector_schedule, load_sample_collector_data_from_backend } from "../utilis/sampleCollectorServices";
import { useGridApiRef } from "@mui/x-data-grid-pro";

const TabContent = ({ tabName, hiddenColumns }) => {
    // const gridRef = useGridApiRef();
    // console.log(hiddenColumns);
    const [data, setData] = useState([]);
    const columnsData = Object.values(sampleCollectorGridColumns);

    const apiRef = useGridApiRef();

    // to load data on tab change
    useEffect(() => {
        load_sample_collector_data_from_backend(data, setData, tabName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    return (
        <>
            {
                data && <CustomDataGrid
                    apiRef={apiRef}
                    processRowUpdate={async (updatedRow, originalRow) => {
                        const result = await edit_sample_collector_schedule(updatedRow, tabName);
                        if (result) return updatedRow;
                        else return originalRow;
                    }
                    }
                    columns={columnsData}
                    rows={data || []}
                    initialState={{
                        columns: {
                            columnVisibilityModel: hiddenColumns,
                        },
                        pinnedColumns: {
                            right: [
                                "spec_id",
                                "stp_id",
                                "market",
                                "sample_type",
                                "expected_delivery_date_by_ip_qa",
                            ]
                        }
                    }}
                    sx={{
                        height: "700px"
                    }}
                />
            }

        </>
    );
};
export default TabContent;